import React from "react";
import Carousel from "./CarouselSlides";
import Banner from "./Banner";
import { MiniCard } from "../common/Card";
import More from "../common/More";
import services from "../../data/servicesData";
import logosData from "../../data/logosData";
import Engineer from "./Engineer";
import "./Home.css";
import oilData from "../../data/oilData";

const Home = () => {
  return (
    <React.Fragment>
      <Carousel />
      <Banner />
      <CardsArea />
      <BrandsArea />
      <h1 className="lemo-font" style={{textAlign:"center"}}>أجود انواع زيوت المحركات</h1>
      <div className="oil-cnt wrapper">
        {oilData.map((oil,i) => <Oil {...oil} key={'oli'+i}/>)}
      </div>
      <Engineer />
    </React.Fragment>
  );
};
export default Home;

const CardsArea = () => {
  return (
    <div
      style={{ backgroundColor: "#fafbfc", paddingTop: "30px" }}
      className="cards-area"
    >
      <div className="wrapper cards-container-grid">
        {services.map(
          (service, i) =>
            service.exclusive ? (
              <MiniCard
                title={service.title}
                desc={service.desc}
                isexclu={service.exclusive}
                advantages={service.advantages}
                src={service.img}
                key={i}
              />
            ) : null
        )}
      </div>
      <More path="services" />
    </div>
  );
};

const BrandsArea = () => {
  return (
    <section className="brands-area ">
      <div className="brands-flex-one wrapper">
        <img
          src="https://mhesham32cdn.netlify.com/img/elmohandess/toyota-car.png"
          alt=""
        />
        <h1 className="lemo-font">نعمل فى أشهر الماركات اليابانية والكورية </h1>
      </div>
      <div className="brands-logo">
        <div className="brands-flex-two wrapper">
          {logosData.map((logo, i) => <BrandLogo {...logo} key={i + 1} />)}
        </div>
      </div>
    </section>
  );
};

const BrandLogo = ({ src, title }) => {
  return <img src={src} title={title} alt={title} />;
};

const Oil = ({ img, title }) => (
  <div className="oil">
    <img src={img} alt="" />
    <h2 className="cairo-font">{title}</h2>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/home/Home.js